import React from 'react';
import { AdminPageHeader, AreaBar } from '../../components/admin/shell';
import ListedProsPanel from '../../components/admin/listedPros/ListedProsPanel';

export default function ListedProsPage() {
  return (
    <>
      <AdminPageHeader section="listed-pros" meta="Directory runs, claims and the business list." />
      <AreaBar note="Runs are started against one area at a time." />
      <ListedProsPanel />
    </>
  );
}
